import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { CampaignsServiceProvider } from '../../api/campaigns'

const CampaignsService = CampaignsServiceProvider()
const name = 'createCampaign'

export default (data) => (asyncAction(
  name,
  CampaignsService.createCampaign,
  data
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/campaign/createCampaign.js